import { render, staticRenderFns } from "./TrafficRequestCreateModal.vue?vue&type=template&id=14097c26&scoped=true"
import script from "./TrafficRequestCreateModal.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestCreateModal.vue?vue&type=script&lang=ts"
import style0 from "./TrafficRequestCreateModal.vue?vue&type=style&index=0&id=14097c26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14097c26",
  null
  
)

export default component.exports